import * as React from 'react';
import { Heading, Block, Text } from '../../../../../../../components';
import { ToggleCard } from '../../../../../components';
import StatusRequest from '../../../../../components/Cards/request/Status';
import { Pin1 } from '../../info/components';
import RegisterForm from './RegisterForm';
import ProcedureHeader from '@/presentation/modules/procedures/components/ContainerProcedure/Header';

const TextTitleHead = ({ title }: any) => (
  <Text
    color="#161D1F"
    fontSize="14px"
    lineHeight="20px"
    fontWeight="700"
    style={{ height: 40, alignItems: 'center', display: 'flex' }}
  >
    {title}
  </Text>
);

const TextTitle = ({ title }: any) => (
  <Heading
    text={title}
    level={2}
    color="var(--neutrals-neutral02)"
    size={18}
    lineHeight={28}
    fontWeight="900"
    className=""
    align="flex-start"
  />
);

const ToggleHeader = ({
  name,
  amount,
  duration,
  pin1,
  status,
  date,
  childContent,
  twoLineFormat,
  inRegister,
  star,
  isMigrated,
  additionalItem,
  perPeriod
}: any) => (
  <ToggleCard isMigrated={isMigrated}>
    <TextTitleHead title={name} />
    <Block customized margin="-4px 0px 0px 0px">
      {status && (
        <Block customized margin="8px 0px 0px 0px">
          <StatusRequest {...status} />
        </Block>
      )}
      <ProcedureHeader
        amount={amount}
        duration={duration}
        date={isMigrated ? null : date}
        twoLineFormat={twoLineFormat}
        inRegister={inRegister}
        star={star}
        additionalItem={additionalItem}
        paddingData={8}
        perPeriod={perPeriod}
      />
    </Block>
    {pin1 ? <Pin1 message={pin1} /> : childContent}
  </ToggleCard>
);

ToggleHeader.defaultProps = {
  twoLineFormat: false
};

export { RegisterForm, TextTitleHead, TextTitle, ToggleHeader };
